import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IThesis } from '../interface/IThesis';

enum ThesisServiceEnum {
  getAll = "",
  save = "",
  saveOrUpdate = "",
  delete = "/"
}

export default class ThesisService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/thesis");
  }

  public getAll = async (): Promise<IThesis[]> => await this.GET(ThesisServiceEnum.getAll);
  public save = async (data: IThesis): Promise<IThesis> => await this.POST(ThesisServiceEnum.save, data);
  public saveOrUpdate = async (data: IThesis): Promise<IThesis> => await this.PUT(ThesisServiceEnum.saveOrUpdate, data);
}
